import { combineReducers } from 'redux';

import error from './error';
import isLoading from './isLoading';
import isReady from './isReady';
import languages from './languages';
import newChecklistTarget from './newChecklistTarget';
import patchingAdvice from './patchingAdvice';
import selectedLocale from './selectedLocale';

const details = combineReducers({
  error,
  isLoading,
  isReady,
  languages,
  newChecklistTarget,
  patchingAdvice,
  selectedLocale,
});

export type ChecklistUiDetailsReducer = ReturnType<typeof details>;

export default details;
